import React from 'react';
import { Table, Button, Tooltip, Typography } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { getSowPipeNumberDisplay } from '../../utils/sowApiFields';
const { Title, Text } = Typography;
const DSRMainlineSelection = ({ mainlines, onSelectMainline }) => {
    const columns = [

        {
            title: 'Pipeline Section',
            dataIndex: 'pipelineSection',
            key: 'pipelineSection',
        },
        {
            title: 'Pipe String ID',
            dataIndex: 'pipeStringId',
            key: 'pipeStringId',
            align: 'center'
        },
        {
            title: 'Material',
            dataIndex: 'material',
            key: 'material',
            align: 'center'
        },
        {
            title: 'Stalk #',
            dataIndex: 'stalkId',
            key: 'stalkId',
            align: 'center'
        },
        {
            title: 'Field Joint Type',
            dataIndex: 'fieldJointType',
            key: 'fieldJointType',
            align: 'center'
        },
        {
            title: 'Report',
            key: 'report',
            align: 'center',
            render: (text, record) => (
                <Tooltip title="Add DSR Report">
                    <div className="new-project-team">
                        <Text onClick={() => onSelectMainline(record)} className="ps-3 add-new-team">
                            <span className="icon-22">
                                <svg>
                                    <use xlinkHref="#add" />
                                </svg>
                            </span>
                        </Text>
                    </div>
                    {/* <Button
                        type="link"
                        icon={<FilePdfOutlined style={{ color: '#ff4d4f', fontSize: 20 }} />}
                        onClick={() => onSelectMainline(record)}
                        style={{ padding: 0 }}
                    /> */}
        </Tooltip>
      ),
    },
  ];

  return (
    <div className="addTeamDetails">
      <Table
        pagination={false}
        columns={columns}
        dataSource={mainlines}
        className="h-100 pipeline-table"
        scroll={{ y: 'calc(100vh - 290px)' }}
        rowKey="id"
      />
    </div>
  );
};

export default DSRMainlineSelection;
